import React from "react";
import { Outlet } from "react-router-dom";

function SfdaMedicineIndex() {
  return <Outlet />;
}

export default SfdaMedicineIndex;
